<div class="head">
  <div class="title">
    {{ formTitle }}
  </div>

  <div class="lead">
    {{ formLead }}
  </div>
</div>
